import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.js";
import { AdminApp } from "./admin/AdminApp.js";

const isAdmin = window.location.pathname.startsWith("/admin");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {isAdmin ? <AdminApp /> : <App />}
  </StrictMode>,
);
